export default {
  ZH_CN: {
    index: "序号",
    total: "共 {total} 条",
    pageSize: "条/页",
    goto: "前往",
    page: "页",
    prevPage: "上一页",
    nextPage: "下一页"
  },
  EN: {
    index: "No.",
    total: "Total {total} items",
    pageSize: "items/page",
    goto: "Go to",
    page: "page",
    prevPage: "Previous page",
    nextPage: "Next page"
  },
  ZH_HK: {
    index: "序號",
    total: "共 {total} 條",
    pageSize: "條/頁",
    goto: "前往",
    page: "頁",
    prevPage: "上一頁",
    nextPage: "下一頁"
  },
  es: {
    index: "N.º",
    total: "Total {total} elementos",
    pageSize: "elementos/página",
    goto: "Ir a",
    page: "página",
    prevPage: "Página anterior",
    nextPage: "Página siguiente"
  }
};
